export enum RacePageResponseType {
  Starters,
  Results,
}
